import { Volume } from "../ordering";
import Fraction from "fraction.js";
export class VolumeParser {
    static parse(volume) {
        return new Volume(new Fraction(volume.numerator, volume.denominator));
    }
}
